import React, { useState } from "react";
import { ButtonProps } from "./types";
import Overlay from "./Overlay";    
import { Image } from "@/components/ui/image";

export const Button: React.FC<ButtonProps> = ({ 
    type,
    buttonKey,
    button, 
    onClick,
    image,
    overlayParagraphs,
    bgColor,
    buttonExtraClasses,
    paragraphWithCopyButton,
    buttons
}) => {
    // Overlay State
    const [overlayContent, setOverlayContent] = useState<{ title: string; content: React.ReactNode } | null>(null);

    // Open Overlay with Specific Content
    const openOverlay = (title: string, content: React.ReactNode) => {
        setOverlayContent({ title, content });
    };

    // Close Overlay
    const closeOverlay = () => {
        setOverlayContent(null);
    };

    return (
        <>
        {(() => {
            const GtmButtonId = `${button} (button)`;
 
            return (
                <button className={`flex overflow-hidden flex-1 shrink gap-[4px] px-[16px] py-[8px] rounded-lg basis-0 h-[36px] items-center tracking-tight w-full text-sm md:text-md font-semibold
                            ${buttonExtraClasses ? buttonExtraClasses : ''}
                            ${bgColor || 'bg-primary'}`}
                    key={String(buttonKey)}
                    id={GtmButtonId}
                    onClick={type === "function" ? onClick : () => openOverlay(button, overlayParagraphs)}
                >
                    <span id={GtmButtonId}>{button}</span>
                    {image && (
                        <img id={GtmButtonId}
                            src={image}
                            alt={button}
                            className="object-contain shrink-0 my-auto ml-auto aspect-[0.79] fill-white h-[18px]"
                        />
                    )}
                </button>
                );
            })()}
            
            {type === "overlay" && overlayContent && (
                <Overlay 
                    title={overlayContent.title} 
                    isOpen={true} 
                    onClose={closeOverlay}
                    paragraphWithCopyButton={paragraphWithCopyButton}
                    buttons={buttons}
                >
                    {overlayContent.content}
                </Overlay>
            )}
        </>
    );
};